import { TelemetryEventTypes } from "@teams/types";
import { UserDTO } from "@teams/types/api";

import { telemetryApi } from "../services/TelemetryApi";

export const clientEventTracker = {
  track: (
    event: TelemetryEventTypes,
    user: UserDTO,
    properties: object,
    userProperties?: object
  ) => {
    telemetryApi.trackEvent(
      event,
      user.userId,
      user.tenantId,
      {
        ...properties,
        ...(navigator ? { userAgent: navigator.userAgent } : {}),
      },
      userProperties
    );
  },
  trackFatalError: (
    event: TelemetryEventTypes,
    user: Pick<UserDTO, "userId" | "tenantId">,
    properties: object
  ) => {
    telemetryApi.trackEvent(
      event,
      user.userId,
      user.tenantId,
      {
        ...properties,
        ...(navigator ? { userAgent: navigator.userAgent } : {}),
      },
      undefined,
      true
    );
  },
};
